/**
 * Connection Status Component
 *
 * Shows WebSocket connection status with visual indicator.
 */

interface ConnectionStatusProps {
  connected: boolean;
  connecting: boolean;
  error?: string | null;
  onReconnect?: () => void;
}

export function ConnectionStatus({
  connected,
  connecting,
  error,
  onReconnect,
}: ConnectionStatusProps) {
  if (connected && !error) {
    return (
      <div className="flex items-center gap-2 text-sm text-green-400">
        <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
        <span>Connected</span>
      </div>
    );
  }

  if (connecting) {
    return (
      <div className="flex items-center gap-2 text-sm text-yellow-400">
        <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse" />
        <span>Connecting...</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-sm text-red-400">
      <div className="w-2 h-2 bg-red-400 rounded-full" />
      <span>{error || 'Disconnected'}</span>
      {onReconnect && (
        <button
          onClick={onReconnect}
          className="ml-2 px-2 py-0.5 text-xs bg-red-500/20 hover:bg-red-500/30 rounded transition-colors"
        >
          Reconnect
        </button>
      )}
    </div>
  );
}

export default ConnectionStatus;
